export type srmPayload = {
  bets: Record<
    string,
    {
      selections: { outcomeIds: string[] }[];
    }
  >;
};

export type srmError = {
  message: string;
  messageTemplate: "market.redundant.selection" | string;
  propertyPath: string;
};

export type srmResponse = {
  bets: Record<string, { odds: number; errors: srmError[] }>;
};

export const requestSameRaceMultiOdds = async ({
  token,
  payload,
  signal,
}: {
  token: string;
  payload: srmPayload;
  signal?: AbortSignal;
}): Promise<srmResponse> => {
  const response = await fetch(process.env.GATSBY_API_URI + `/betting/odds`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(payload),
    signal,
  });

  const body = await response.json();
  if (response.ok) {
    return body;
  } else {
    throw body;
  }
};
